/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { GPIOMode } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class GpioService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get GPIO variable mode
   *
   * LWM2M path: /1029/{variableId}/4
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getGpioMode(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<GPIOMode>> {
    return this.serviceCallRunner.execute(this.getGpioModeCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/4
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getGpioModeCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getGpioMode };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }
}
